module.exports = __webpack_public_path__ + "fonts/merriweather-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Merriweather/merriweather-regular-webfont.woff
// module id = 3435
// module chunks = 0